<template>
  <!-- TODO: Use re-field to get validations -->
  <re-input
    :model-value="prettyModel"
    v-bind="$attrs"
  >
    <q-popup-proxy
      ref="popupEl"
      transition-show="scale"
      transition-hide="scale"
    >
      <div class="row">
        <q-date
          v-model="modelWrapper"
          mask="x"
          first-day-of-week="1"
          @update:model-value="hidePopup"
        />
        <q-time
          v-if="props.showTime"
          v-model="modelWrapper"
          mask="x"
          format24h
        />
      </div>
      <div class="row items-center justify-end">
        <q-btn
          v-close-popup
          label="Clear"
          color="main"
          flat
          @click="selectedDateTime = null"
        />
        <q-btn
          v-close-popup
          label="Close"
          color="main"
          flat
        />
      </div>
    </q-popup-proxy>
  </re-input>
</template>
<script setup>
import { computed, ref } from 'vue'

import { useGlobals } from '@/main'

const props = defineProps({
  showTime: {
    type: Boolean,
    default: true,
  },
})
const { $format } = useGlobals()

const popupEl = ref()

const selectedDateTime = defineModel({
  type: [Date, null],
})

function hidePopup() {
  if (!props.showTime) {
    popupEl.value.hide()
  }
}

const prettyModel = computed(() => {
  if (!selectedDateTime.value) return null

  if (props.showTime) {
    return $format.datetime(selectedDateTime.value)
  } else {
    return $format.date(selectedDateTime.value)
  }
})

const modelWrapper = computed({
  get() {
    if (!selectedDateTime.value) return null

    return selectedDateTime.value?.getTime().toString()
  },
  set(v) {
    selectedDateTime.value = !v ? null : new Date(Number(v))
  },
})
</script>
